export const LOCAL_STORAGE_KEYS = {
  DEFAULT_HOLDINGS_TABLE_SETTINGS: 'default-holdings-table-settings',
  DEFAULT_OPPORTUNITIES_COLUMNS: 'default-opportunities-columns',
  DEFAULT_TAX_OVERVIEW_COLUMNS: 'default-tax-columns',
  DEFAULT_CLIENTS_COLUMNS: 'default-clients-columns',
  DEFAULT_ACCOUNTS_COLUMNS: 'default-accounts-columns',
  ACCOUNTS_SAVED_FILTERS: 'accounts-saved-filters',
  ACCOUNTS_ACTIVE_FILTER_PRESET_ID: 'accounts-active-filter-preset-id',
  DEFAULT_SCHEDULED_MEETINGS_COLUMNS: 'default-scheduled-meetings-columns',
  TASKS_PAGE_FIRST_TIME_VISITED: 'tasks-page-first-time-visited',
  TASKS_SORT: 'tasks-sort',
  DEFAULT_TASKS_COLUMNS: 'default-tasks-columns',
  DEFAULT_WORKFLOWS_COLUMNS: 'default-workflows-columns',
  DEFAULT_MEETING_AGENDA_TEMPLATES_COLUMNS: 'default-meeting-agenda-templates-columns',
  WORKFLOWS_SAVED_FILTERS: 'workflows-saved-filters',
  WORKFLOWS_ACTIVE_FILTER_PRESET_ID: 'workflows-active-filter-preset-id',
  TASKS_FILTER_PREFERENCES: 'tasks-filter-preferences',
  DOCUSIGN_TRACKER_FILTER_PREFERENCES: 'docusign-tracker-filter-preferences',
  DOCUSIGN_TRACKER_SAVED_FILTERS: 'docusign-tracker-saved-filters',
  DOCUSIGN_TRACKER_ACTIVE_FILTER_PRESET_ID: 'docusign-tracker-active-filter-preset-id',
  TASKS_SAVED_FILTERS: 'tasks-saved-filters',
  TASKS_ACTIVE_FILTER_PRESET_ID: 'tasks-active-filter-preset-id',
  CLIENTS_SAVED_FILTERS: 'clients-saved-filters',
  CLIENTS_ACTIVE_FILTER_PRESET_ID: 'clients-active-filter-preset-id',
  COI_REPS_SAVED_FILTERS: 'coi-reps-saved-filters',
  COI_REPS_ACTIVE_FILTER_PRESET_ID: 'coi-reps-active-filter-preset-id',
  TAGS_SAVED_FILTERS: 'tags-saved-filters',
  TAGS_ACTIVE_FILTER_PRESET_ID: 'tags-active-filter-preset-id',
  OPPORTUNITIES_SAVED_FILTERS: 'opportunities-saved-filters',
  OPPORTUNITIES_ACTIVE_FILTER_PRESET_ID: 'opportunities-active-filter-preset-id',
  TAX_SAVED_FILTERS: 'tax-saved-filters',
  TAX_ACTIVE_FILTER_PRESET_ID: 'tax-active-filter-preset-id',
  ALT_FUNDS_SAVED_FILTERS: 'alt-funds-saved-filters',
  ALT_FUNDS_ACTIVE_FILTER_PRESET_ID: 'alt-funds-active-filter-preset-id',
  DEFAULT_SERVICE_SCHEDULES_COLUMNS: 'default-service-schedules-columns',
  DEFAULT_SERVICE_CALENDAR_V3_COLUMNS: 'default-service-calendar-v3-columns',
  SERVICE_SCHEDULES_SAVED_FILTERS: 'service-schedules-saved-filters',
  SERVICE_SCHEDULES_ACTIVE_FILTER_ID: 'service-schedules-active-filter-id',
  SERVICE_TEMPLATE_NOTIFICATION_BANNER_DISMISSED: 'service-template-notification-banner-dismissed',
  NOTIFICATIONS_FILTER_PREFERENCES: 'notifications-filter-preferences',
  NOTIFICATIONS_SAVED_FILTERS: 'notifications-saved-filters',
  NOTIFICATIONS_ACTIVE_FILTER_PRESET_ID: 'notifications-active-filter-preset-id',
  NOTIFICATIONS_V2_INBOX_SAVED_FILTERS: 'notifications-v2-inbox-saved-filters',
  NOTIFICATIONS_V2_ACTIVITY_SAVED_FILTERS: 'notifications-v2-activity-saved-filters',
  CONNECT_ACCOUNTS_NUDGE_CARD_DISMISSED_AT: 'connect-accounts-nudge-card-dismissed-at',
  CLIENT_PORTAL_PORTFOLIO_SPLASH_DISMISSED: 'client-portal-portfolio-splash-dismissed',
  DISCONNECTED_ACCOUNTS_BANNER_DISMISSAL: 'disconnected-accounts-banner-dismissal',
  HOUSEHOLD_EXPORT_SAVED_PRESETS: 'household-export-saved-presets',
  TIMELINE_ITEM_DENSITY: 'timeline-item-density',
  /**
   * One per overview-rail surface — holds `{ order, collapsed, hidden, tabOrder }`, see
   * `overview-rail-preference.ts`.
   * The `:panel-order` value strings predate collapse state and stay as they are for back-compat.
   */
  HOUSEHOLD_OVERVIEW_RAIL_PREFERENCE: 'household-overview:panel-order',
  HOUSEHOLD_CONTACT_OVERVIEW_RAIL_PREFERENCE: 'household-contact-overview:panel-order',
  PROFESSIONAL_CONTACT_OVERVIEW_RAIL_PREFERENCE: 'professional-contact-overview:panel-order',
  COMPANY_OVERVIEW_RAIL_PREFERENCE: 'company-overview:panel-order',
  /** Suffixed with `:<householdId>` — one entry per household. */
  CANVAS_LAST_ACTIVE_DOCUMENT: 'canvas-last-active-document',
  /**
   * Suffixed with `:<householdPublicId>` — one entry per household. Stands in for real plan data;
   * delete alongside the `hasPlan` placeholder once plans live in the DB.
   */
  RETIREMENT_PLAN_STARTED: 'retirement-plan-started',
} as const;
